import React from 'react';
import './style.scss';

function ModuleTopBar(props) {
    return (
        <div className="module-topbar">
            {props.children}
        </div>
    )
}

export default ModuleTopBar
